module.exports = __webpack_public_path__ + "static/Underdown4-68fc94805580907dfdb769c0dd04461e.webp";